import { useSyncExternalStore } from 'react';

// Aula aberta na tela de estudo do aluno, para a bolha "Ajuda" (AjudaWidget) oferecer a
// "Dúvida sobre esta aula". Quem registra é o DuvidaIA (no modo 'ia'), montado pela tela de estudo;
// ao sair da aula ele limpa. Fica só na memória da página.

let aulaAtual = null;
const ouvintes = new Set();

export const definirAulaAberta = (aula) => {
  const nova = aula && aula.turmaId && aula.aulaId
    ? { turmaId: aula.turmaId, aulaId: aula.aulaId, aulaTitulo: aula.aulaTitulo || '' }
    : null;
  const igual = (nova === null && aulaAtual === null)
    || (nova && aulaAtual && nova.turmaId === aulaAtual.turmaId && nova.aulaId === aulaAtual.aulaId && nova.aulaTitulo === aulaAtual.aulaTitulo);
  if (igual) return;
  aulaAtual = nova;
  ouvintes.forEach((f) => f());
};

export const aulaAberta = () => aulaAtual;

const inscrever = (f) => {
  ouvintes.add(f);
  return () => ouvintes.delete(f);
};

export const useAulaAberta = () => useSyncExternalStore(inscrever, aulaAberta, aulaAberta);
